import React from 'react';
import { Top } from '../pages/top/Top';
import { PassReset } from '../pages/top/PassReset';
const routes = [
    {
        path: '/',
        exact: true,
        children: React.createElement(Top, null),
        component: Top,
    },
    {
        path: '/pass_reset',
        children: React.createElement(PassReset, null),
        exact: true,
        component: PassReset,
    },
];
export default routes;
